import { CreditUsageType } from '../definition';

export const CreditUsageTitle: Record<CreditUsageType, string> = {
  CONTACT_PROFILE_REVEAL: 'Unlock Profile Insights',
  CONTACT_PROFILE_UPDATE: 'Saved Contact — Data Update',
  CONTACT_EMAIL_FINDING: 'Valid Email Found',
  CONTACT_EMAIL_REVERIFICATION: 'Saved Email — Re-Validate',
  CONTACT_PHONE_FINDING: 'Mobile Found',
  CONTACT_STORAGE_BASIC: 'Basic Contact Storage',
  CONTACT_STORAGE_ENRICH: 'Saved Contact — Job Change',
  CONTACT_STORAGE_AI: 'Lookalike Contact Storage',
  ACCOUNT_STORAGE_BASIC: 'Basic Company Storage',
  ACCOUNT_STORAGE_AI: 'Lookalike Company Storage',
  CONTACT_ANALYSIS_REVEAL: 'AI Analysis — Unlock',
  CONTACT_ANALYSIS_UPDATE: 'AI Analysis — Update',
  CONTACT_EMAIL_GUESS_RETRIEVAL: 'Email Guess Retrieval',
  ACCOUNT_STORAGE_ENRICH: 'Saved Company — Data Update',
};

/** Display order for credit usage lists (e.g. pricing “How credits work”). */
export const CREDIT_USAGE_DISPLAY_ORDER: readonly CreditUsageType[] = [
  CreditUsageType.CONTACT_PROFILE_REVEAL,
  CreditUsageType.CONTACT_PROFILE_UPDATE,
  CreditUsageType.CONTACT_EMAIL_FINDING,
  CreditUsageType.CONTACT_EMAIL_REVERIFICATION,
  CreditUsageType.CONTACT_PHONE_FINDING,
  CreditUsageType.CONTACT_STORAGE_BASIC,
  CreditUsageType.CONTACT_STORAGE_ENRICH,
  CreditUsageType.CONTACT_STORAGE_AI,
  CreditUsageType.ACCOUNT_STORAGE_BASIC,
  CreditUsageType.ACCOUNT_STORAGE_AI,
  CreditUsageType.CONTACT_ANALYSIS_REVEAL,
  CreditUsageType.CONTACT_ANALYSIS_UPDATE,
  CreditUsageType.CONTACT_EMAIL_GUESS_RETRIEVAL,
  CreditUsageType.ACCOUNT_STORAGE_ENRICH,
] as const;
